import PropTypes from 'prop-types';
import {Loader, Message} from 'semantic-ui-react';

export default function LoadingMessage({children, header, style}) {
  return (
    <Message size="big" icon info style={style}>
      <Loader size="big" active inline/>
      <Message.Content style={{paddingLeft: '1em'}}>
        <Message.Header>{header}</Message.Header>
        {children}
      </Message.Content>
    </Message>
  );
}
LoadingMessage.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.node.isRequired,
  style: PropTypes.object,
};
